import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getProductos,
  deleteProducto,
  getProductoById,
  insertProducto,
  updateProducto,
  getMapas,
  getProductosFiltered,
  deleteProductoList,
  getProductosByIds,
  getProductosAvatares,
} from 'services/catalogo'
import constants from 'services/constants'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PRODUCTOS_FILTERED(action) {
  try {
    const productosData = yield call(getProductosFiltered, action.payload)
    if (productosData.ok) {
      yield put({
        type: actions.PRODUCTOS_LOAD_SUCCEEDED,
        payload: productosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar productos')
      put({
        type: actions.PRODUCTOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PRODUCTOS_ADICIONALES() {
  try {
    const filter = { categoriasId: [constants.CATEGORIA_PERSONALIZADA_ID] }
    const productosAdicionalesData = yield call(getProductosFiltered, filter)
    if (productosAdicionalesData.ok) {
      yield put({
        type: actions.PRODUCTOS_ADICIONALES_LOAD_SUCCEEDED,
        payload: productosAdicionalesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar productos adicionales')
      put({
        type: actions.PRODUCTOS_ADICIONALES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_ADICIONALES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PRODUCTOS_AVATARES() {
  try {
    const productosData = yield call(getProductosAvatares)
    if (productosData.ok) {
      yield put({
        type: actions.PRODUCTOS_AVATARES_LOAD_SUCCEEDED,
        payload: productosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar productos de avatares')
      put({
        type: actions.PRODUCTOS_AVATARES_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_AVATARES_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PRODUCTOS() {
  try {
    const productosData = yield call(getProductos)
    if (productosData.ok) {
      yield put({
        type: actions.PRODUCTOS_LOAD_SUCCEEDED,
        payload: productosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar productos')
      put({
        type: actions.PRODUCTOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_MAPAS() {
  try {
    const mapasData = yield call(getMapas)
    if (mapasData.ok) {
      yield put({
        type: actions.MAPAS_LOAD_SUCCEEDED,
        payload: mapasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar mapas')
      put({
        type: actions.MAPAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.MAPAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PRODUCTO_BY_ID(action) {
  try {
    const productoData = yield call(getProductoById, action.payload)
    if (productoData.ok) {
      yield put({
        type: actions.PRODUCTO_BYID_LOAD_SUCCEEDED,
        payload: productoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar producto')
      put({
        type: actions.PRODUCTO_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTO_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PRODUCTO(action) {
  try {
    const productoObj = yield call(updateProducto, action.payload)
    if (productoObj.ok) {
      putMessage(messageType.SUCCESS, 'Producto modificado correctamente')
      yield put({
        type: actions.PRODUCTO_UPDATE_SUCCEEDED,
        payload: productoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar producto')
      yield put({
        type: actions.PRODUCTO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificadar producto')
    yield all([
      put({
        type: actions.PRODUCTO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_PRODUCTO(action) {
  try {
    const productoObj = yield call(insertProducto, action.payload)
    if (productoObj.ok) {
      putMessage(messageType.SUCCESS, 'Producto creado correctamente')
      yield put({
        type: actions.PRODUCTO_INSERT_SUCCEEDED,
        payload: productoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear producto')
      yield put({
        type: actions.PRODUCTO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear producto')
    yield all([
      put({
        type: actions.PRODUCTO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_PRODUCTO(action) {
  try {
    const productoResult = yield call(deleteProducto, action.payload)
    if (productoResult.ok) {
      putMessage(messageType.SUCCESS, 'Producto eliminado correctamente')
      yield put({
        type: actions.PRODUCTO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar producto')
      yield put({
        type: actions.PRODUCTO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar producto')
    yield all([
      put({
        type: actions.PRODUCTO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_PRODUCTOS(action) {
  try {
    const productosResult = yield call(deleteProductoList, action.payload)
    if (productosResult.ok) {
      putMessage(messageType.SUCCESS, 'Productos eliminados correctamente')
      yield put({
        type: actions.PRODUCTOS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar productos')
      yield put({
        type: actions.PRODUCTOS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar productos')
    yield all([
      put({
        type: actions.PRODUCTOS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PRODUCTOS_BY_IDS(action) {
  try {
    const response = yield call(getProductosByIds, action.payload)
    if (response.ok) {
      yield put({
        type: actions.PRODUCTOS_BYID_LOAD_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar productos')
      put({
        type: actions.PRODUCTOS_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PRODUCTOS_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PRODUCTOS_LOAD_REQUESTED, GET_PRODUCTOS),
    takeEvery(actions.PRODUCTOS_LOAD_FILTERED_REQUESTED, GET_PRODUCTOS_FILTERED),
    takeEvery(actions.MAPAS_LOAD_REQUESTED, GET_MAPAS),
    takeEvery(actions.PRODUCTO_BYID_LOAD_REQUESTED, GET_PRODUCTO_BY_ID),
    takeEvery(actions.PRODUCTO_UPDATE_REQUESTED, UPDATE_PRODUCTO),
    takeEvery(actions.PRODUCTO_INSERT_REQUESTED, INSERT_PRODUCTO),
    takeEvery(actions.PRODUCTO_DELETE_REQUESTED, DELETE_PRODUCTO),
    takeEvery(actions.PRODUCTOS_DELETE_REQUESTED, DELETE_PRODUCTOS),
    takeEvery(actions.PRODUCTOS_ADICIONALES_LOAD_REQUESTED, GET_PRODUCTOS_ADICIONALES),
    takeEvery(actions.PRODUCTOS_BYID_LOAD_REQUESTED, GET_PRODUCTOS_BY_IDS),
    takeEvery(actions.PRODUCTOS_AVATARES_LOAD_REQUESTED, GET_PRODUCTOS_AVATARES),
  ])
}
